import React, { useState, useEffect } from "react";
import { apiGet, apiPost } from "api/callApi";
import { useLocation, useNavigate } from "react-router";
import { Breadcrumbs, InnoTable, Popover, TableList } from "InnoUI/components";
import InnoIcons from "InnoUI/innoicons";
import SC from "./style";
import AddEditFolderTemplate from "./AddEditFolderTemplate";
import {
  formatDateTime,
  innoTableConfig,
  innoTableConfigsecond,
  InnoTableDefaultPageSize,
} from "utils/config";
import { Switch } from "antd";
import theme from "theme";
import TimezoneConverter from "components/TimeZoneConvertor";
import { showAlert } from "utils/helper";

const FolderTemplate = (props) => {
  const { popupState } = props;
  const location = useLocation();
  const currentPath = location.pathname;
  const [isEditing, setIsEditing] = useState(false);
  const [fieldData, setFieldData] = useState();
  const [rowData, setRowData] = useState();
  const [folderData, setFolderData] = useState();
  const [openModalView, setOpenModalView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  const navigate = useNavigate();
  const openAddFolderModal = () => {
    setOpenModalView(true);
  };

  const onRowClick = (data) => {
    setIsEditing(true);
    setOpenModalView(true);
    setFieldData(data);
    setRowData(data.id);
  };

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Folder Template", href: "/admin-settings/folder-template" },
  ];

  const getAlldata = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet(`/v1/templates`, false);
      setFolderData(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    getAlldata();
  }, []);

  const handleTemplateClick = (data) => {
    navigate(`/admin-settings/folder-template/permission-and-structure`, {
      state: { data },
    });
  };

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href);
    }
  };

  const handleChange = async (id, value) => {
    const data = { status: value };
    const response = await apiPost(`/v1/templates/${id}`, data);
    showAlert({ title: "Success", text: response?.message, icon: "success" });
    await getAlldata();
    try {
    } catch (error) {
      console.error("Error updating company data:", error);
      showAlert({
        title: "Error",
        text: "Failed to update company data",
        icon: "error",
      });
    }
  };

  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 80,
      render(value, record, index) {
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },
    {
      title: "Template Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      width: 350,
      onCell: () => ({}),
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Open",
            onClick: () => handleTemplateClick(record),
          },
          {
            id: 1,
            text: "Edit",
            onClick: (e) => {
              e.stopPropagation();
              onRowClick(record);
            },
          },
        ];

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <SC.ValueSpanP>{value}</SC.ValueSpanP>
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <>
                    <div
                      style={{
                        width: "50px",
                        textAlign: "center",
                        justifyContent: "end",
                        display: "flex",
                        marginRight: "5px",
                      }}
                    >
                      <SC.PopoverSpan>
                        <SC.MoreVertIcon />
                      </SC.PopoverSpan>
                    </div>
                  </>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                  }}
                  items={menuItems || []}
                  popupState={popupState}
                />
              }
            />
          </div>
        );
      },
    },

    {
      title: "Last Modified Date & Time",
      dataIndex: "lastUpdate",

      width: 350,

      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <SC.ValueSpan>
              <TimezoneConverter time={value} />
            </SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Created By",
      dataIndex: "createdByName",
      width: 350,

      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <SC.ValueSpan>{value}</SC.ValueSpan>
          </>
        );
      },
    },
    /*  {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (value, record) => (
        <Switch
          checked={value}
          onChange={(checked) => handleChange(record.id, checked ? 1 : 0)}
          style={{
            transform: "scale(0.7)",
            backgroundColor: value ? `${theme.colors.themeColor}` : undefined,
            borderColor: value ? `${theme.colors.themeColor}` : undefined,
          }}
        />
      ),
    }, */
  ];
  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: true,
    search: true,
    action: false,
    divBorder: true,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
    sno: false,
    searchPlaceholder: "Search by Template name",
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
        onClick={handleBreadcrumbClick}
      />
      <SC.BodyContainer>
        <SC.Container>
          <InnoTable
            tableConfig={tableConfig}
            padding={"8px 8px 8px 8px"}
            column={subColumnData}
            data={folderData}
            tableKey={"Folder Template"}
            onAddDataCallback={openAddFolderModal}
            onRowClickCallback={onRowClick}
            ComponnentName={"Folder Template"}
            searchKeys={["name", "createdByName"]}
            loading={isLoading}
            onRow={(record) => ({
              onClick: (event) => {
                setTimeout(() => {
                  if (!document.querySelector(".ant-image-preview-mask")) {
                    handleTemplateClick(record);
                  }
                }, 100);
              },
            })}
          />
        </SC.Container>
      </SC.BodyContainer>
      {openModalView && (
        <AddEditFolderTemplate
          isEditing={isEditing}
          setOpenModalView={setOpenModalView}
          setIsEditing={setIsEditing}
          openModalView={openModalView}
          fieldData={fieldData}
          rowData={rowData}
          fetchData={getAlldata}
          setFieldData={setFieldData}
        />
      )}
    </>
  );
};

export default FolderTemplate;
